import Stickyfill from 'stickyfilljs';

const stickies = document.querySelectorAll('.sticky');
Stickyfill.add(stickies);
